import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
  SiRedux,
  SiReact,
} from "react-icons/si";
import { DiCss3, DiReact } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different">Projects</h2>
        <div className="allProjects">
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://github.com/NayanIngale1/FRAAZO-CLONE/blob/main/Demo/loginPopup.png?raw=true"
                    alt="Fraazo-clone"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>FRAAZO - Clone</h2>
                <p>
                  About This is clone of fraazo website. Fraazo follows a
                  farm-to-fork model where it owns the entire back-end supply
                  chain starting with farmers, and delivers them fresh to
                  customers.
                </p>
                <div>
                  <SiReact />
                  <SiRedux />
                  <IoLogoJavascript />
                  <DiCss3 />
                  <SiExpress />
                  <SiMongodb />
                </div>
                <div>
                  <a
                    href="https://fraazo-clone-ningale.vercel.app"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/NayanIngale1/FRAAZO-CLONE"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://raw.githubusercontent.com/NayanIngale1/Professional-FullStack-Todo-APP/main/Demo/all.png"
                    alt="professional-todo-app"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>FullStack Todo App</h2>
                <p>
                  This is Full Stack TODO app where you can store your personal,
                  proffesional and other todos with their subtasks. You can also
                  edit them later. All the user Information and All the todos
                  are stored in Backend.
                </p>
                <div>
                  <SiReact />
                  <SiRedux />
                  <IoLogoJavascript />
                  <DiCss3 />
                  <SiExpress />
                  <SiMongodb />
                </div>
                <div>
                  <a
                    href="https://professional-todo-app.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/NayanIngale1/Professional-FullStack-Todo-APP"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://iili.io/ViyK57.png" alt="Rockstar Games" />
                </div>
              </div>
              <div className="project_information">
                <h2>Coursera Clone</h2>
                <p>
                  Coursera is a global online learning platform that offers
                  anyone, anywhere, access to online courses and degrees from
                  leading universities and companies. we build a clone of their
                  store website.
                </p>
                <div>
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                  <SiExpress />
                  <SiMongodb />
                </div>
                <div>
                  <a
                    href="https://clonecoursera.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/NayanIngale1/Coursera_Backend"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://iili.io/ViyCzu.png" alt="Sk-Weather-App" />
                </div>
              </div>
              <div className="project_information">
                <h2>Big Basket Clone</h2>
                <p>
                  Big Basket is one of the largest online grocery supermarket in
                  India. The company primarily delivers grocery goods found in
                  convenience stores, home essentials and food supplies to its
                  customers. we build clone of their store website.
                </p>
                <div>
                  <SiHtml5 />
                  <DiCss3 />
                  <IoLogoJavascript />
                </div>
                <div>
                  <a
                    href="https://bigbasketcloneproject.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/NayanIngale1/Fw15-u2-Bigbasket-clone-project"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://iili.io/Viyzqx.png" alt="" />
                </div>
              </div>
              <div className="project_information">
                <h2>Weather App</h2>
                <p>
                  Location-based weather app. Users can also search for their
                  cities and see the location from map and weather data of
                  respective places.
                </p>
                <div>
                  <SiHtml5 />
                  <DiCss3 />
                  <IoLogoJavascript />
                </div>
                <div>
                  <a
                    href="https://liveweatherpage.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/NayanIngale1/weathe-forecast-page"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div> */}

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://iili.io/ViyTgV.png" alt="" />
                </div>
              </div>
              <div className="project_information">
                <h2>Classic TicTacToe</h2>
                <p>
                  Mini project of A classic TicTacToe game built using
                  JavaScript. Features: Button for Resetting The Game,
                  Multiplayer, dark & light Theme etc.
                </p>
                <div>
                  <SiHtml5 />
                  <DiCss3 />
                  <IoLogoJavascript />
                </div>
                <div>
                  <a
                    href="https://tic-tac-toe-nayan.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this live
                    </span>
                  </a>
                  <a
                    href="https://github.com/NayanIngale1/Tic-Tac-Toe-Game"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://iili.io/ViyR5P.png" alt="Uniqlo-Clone" />
                </div>
              </div>
              <div className="project_information">
                <h2>Hungry Recipes</h2>
                <p>
                  Hungry Recipes is a recipe finder that gives you recipes for
                  various foods made with TheMealDB API. It has Search
                  debouncing for finding recipes.
                </p>
                <div>
                  <SiHtml5 />
                  <DiCss3 />
                  <IoLogoJavascript />
                </div>
                <div>
                  <a
                    href="https://hungry-findreceipe.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/NayanIngale1/SearchMealReceipe_App"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
